import React from 'react';

import { GUIDE_TEXT_MAX_WIDTH, GuideMythCard } from '@backrs_ui/grow-ui/src/components/GuidePage';
import type { GpaGuideMythsVsReality } from '@backrs_ui/grow-ui/src/pages/GpaGuide/content/types';

import { Box, SxProps, Theme, Typography } from '@mui/material';

type MythsVsRealitySectionProps = Readonly<{
  content: GpaGuideMythsVsReality;
}>;

export const MythsVsRealitySection: React.FC<MythsVsRealitySectionProps> = ({ content }) => (
  <Box sx={containerSx}>
    <Typography variant="text-md-regular" sx={introSx}>
      {content.intro}
    </Typography>

    <Box sx={gridSx}>
      {content.myths.map((myth) => (
        <GuideMythCard
          key={myth.title}
          type="myth"
          label={content.mythLabel}
          title={myth.title}
          body={myth.body}
        />
      ))}
    </Box>
  </Box>
);

const containerSx: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
};

const introSx: SxProps<Theme> = ({ backrs }) => ({
  color: backrs.colors['Colors/Text/text-tertiary'],
  mb: backrs.spacing['spacing-3xl'],
  maxWidth: GUIDE_TEXT_MAX_WIDTH,
});

const gridSx: SxProps<Theme> = ({ backrs }) => ({
  display: 'grid',
  gridTemplateColumns: '1fr',
  gap: backrs.spacing['spacing-xl'],
  '@container (min-width: 720px)': {
    gridTemplateColumns: 'repeat(2, 1fr)',
  },
});
